import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AngularFireAuth } from "@angular/fire/auth";
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-response-ok',
  templateUrl: './response-ok.component.html',
  styleUrls: ['./response-ok.component.sass']
})
export class ResponseOkComponent implements OnInit {
  public selectedLanguageFlag: string = 'es';

  showPasswordResetProgressSpinner: boolean = true;
  hide: boolean = true;
  success: boolean = false;
  paymentRef: any = '';

  constructor(
    private route: ActivatedRoute, private translate: TranslateService, private auth: AngularFireAuth, private router: Router, private dataService: DataService) { }

  ngOnInit(): void {
    this.auth.user.subscribe(user => {

      if (user) {

        this.dataService.getLang().subscribe(res => {
          // 
          this.translate.use(res.toString());
          // TODO insert here the control of superadmin, family and school 

        });


        this.route.params.subscribe(res => {
          this.paymentRef = res.id;
        })

      } else {
        this.router.navigate(['/login']);
      }
    })
  }


  changeLang(lang: string) {
    this.translate.use(lang);
    localStorage.setItem('language', lang);
    this.selectedLanguageFlag = lang
  }


}
